module.exports = __webpack_public_path__ + "static/media/arch6.67f8b45c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arch6.jpg
// module id = 5792
// module chunks = 0